import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import * as o from 'react';
var oe = Object.defineProperty;
var v = Object.getOwnPropertySymbols;
var W = Object.prototype.hasOwnProperty,
    j = Object.prototype.propertyIsEnumerable;

var U = function U(e, t, r) {
  return t in e ? oe(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    m = function m(e, t) {
  for (var r in t || (t = {})) {
    W.call(t, r) && U(e, r, t[r]);
  }

  if (v) {
    var _iterator = _createForOfIteratorHelper(v(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        j.call(t, r) && U(e, r, t[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

var F = function F(e, t) {
  var r = {};

  for (var c in e) {
    W.call(e, c) && t.indexOf(c) < 0 && (r[c] = e[c]);
  }

  if (e != null && v) {
    var _iterator2 = _createForOfIteratorHelper(v(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var c = _step2.value;
        t.indexOf(c) < 0 && j.call(e, c) && (r[c] = e[c]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
};

var f = function f(e, t) {
  var r = "[react-use-intercom]";

  switch (e) {
    case "info":
      console.log("".concat(r, " ").concat(t));
      break;

    case "warn":
      console.warn("".concat(r, " ").concat(t));
      break;

    case "error":
      console.error("".concat(r, " ").concat(t));
      break;

    default:
      console.log("".concat(r, " ").concat(t));
  }
};

var I = typeof window == "undefined",
    A = function A(e) {
  return Object.keys(e).forEach(function (t) {
    e[t] && typeof e[t] == "object" ? A(e[t]) : e[t] === void 0 && delete e[t];
  }), e;
};

var re = function re(e) {
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  if (!I && window.Intercom) return window.Intercom.apply(null, [e].concat(t));
  f("error", "".concat(e, " Intercom instance is not initalized yet"));
},
    s = re;

var ne = o.createContext(void 0),
    P = ne;

var ae = function ae(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var r = window,
      c = r.Intercom;
  if (typeof c == "function") c("reattach_activator"), c("update", r.intercomSettings);else {
    var w = document,
        u = function u() {
      u.c(arguments);
    };

    u.q = [], u.c = function (l) {
      u.q.push(l);
    }, r.Intercom = u;

    var g = function g() {
      setTimeout(function () {
        var l = w.createElement("script");
        l.type = "text/javascript", l.async = !0, l.src = "https://widget.intercom.io/widget/" + e;
        var d = w.getElementsByTagName("script")[0];
        d.parentNode.insertBefore(l, d);
      }, t);
    };

    document.readyState === "complete" ? g() : r.attachEvent ? r.attachEvent("onload", g) : r.addEventListener("load", g, !1);
  }
},
    G = ae;

var se = function se(e) {
  return {
    custom_launcher_selector: e.customLauncherSelector,
    alignment: e.alignment,
    vertical_padding: e.verticalPadding,
    horizontal_padding: e.horizontalPadding,
    hide_default_launcher: e.hideDefaultLauncher,
    session_duration: e.sessionDuration,
    action_color: e.actionColor,
    background_color: e.backgroundColor
  };
},
    J = function J(e) {
  return m({
    company_id: e.companyId,
    name: e.name,
    created_at: e.createdAt,
    plan: e.plan,
    monthly_spend: e.monthlySpend,
    user_count: e.userCount,
    size: e.size,
    website: e.website,
    industry: e.industry
  }, e.customAttributes);
},
    ce = function ce(e) {
  return {
    type: e.type,
    image_url: e.imageUrl
  };
},
    ie = function ie(e) {
  var t;
  return m({
    email: e.email,
    user_id: e.userId,
    created_at: e.createdAt,
    name: e.name,
    phone: e.phone,
    last_request_at: e.lastRequestAt,
    unsubscribed_from_emails: e.unsubscribedFromEmails,
    language_override: e.languageOverride,
    utm_campaign: e.utmCampaign,
    utm_content: e.utmContent,
    utm_medium: e.utmMedium,
    utm_source: e.utmSource,
    utm_term: e.utmTerm,
    avatar: e.avatar && ce(e.avatar),
    user_hash: e.userHash,
    company: e.company && J(e.company),
    companies: (t = e.companies) == null ? void 0 : t.map(J)
  }, e.customAttributes);
},
    y = function y(e) {
  return A(m(m({}, se(e)), ie(e)));
};

var me = function me(le) {
  var _ = le,
      e = _.appId,
      _$autoBoot = _.autoBoot,
      t = _$autoBoot === void 0 ? !1 : _$autoBoot,
      r = _.autoBootProps,
      c = _.children,
      w = _.onHide,
      u = _.onShow,
      g = _.onUnreadCountChange,
      l = _.onUserEmailSupplied,
      _$shouldInitialize = _.shouldInitialize,
      d = _$shouldInitialize === void 0 ? !I : _$shouldInitialize,
      R = _.apiBase,
      X = _.initializeDelay,
      Y = F(_, ["appId", "autoBoot", "autoBootProps", "children", "onHide", "onShow", "onUnreadCountChange", "onUserEmailSupplied", "shouldInitialize", "apiBase", "initializeDelay"]);
  var p = o.useRef(!1),
      x = o.useRef(!1),
      b = Object.keys(Y).filter(function (n) {
    return !n.startsWith("data-");
  });
  b.length > 0 && f("warn", ["some invalid props were passed to IntercomProvider. ", "Please check following props: ".concat(b.join(", "), ".")].join(""));

  var C = o.useCallback(function (n) {
    if (!window.Intercom && !d) {
      f("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
      return;
    }

    if (p.current) return;
    var i = m(m({
      app_id: e
    }, R && {
      api_base: R
    }), n && y(n));
    window.intercomSettings = i, s("boot", i), p.current = !0;
  }, [R, e, d]),
      _o$useState = o.useState(!1),
      _o$useState2 = _slicedToArray(_o$useState, 2),
      k = _o$useState2[0],
      h = _o$useState2[1],
      Z = o.useCallback(function () {
    h(!1), w && w();
  }, [w, h]),
      ee = o.useCallback(function () {
    h(!0), u && u();
  }, [u, h]);

  !I && d && !x.current && (G(e, X), s("onHide", Z), s("onShow", ee), s("onUserEmailSupplied", l), g && s("onUnreadCountChange", g), t && C(r), x.current = !0);
  var a = o.useCallback(function (n, i) {
    if (!window.Intercom && !d) {
      f("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
      return;
    }

    if (!p.current) {
      f("warn", ["\"".concat(n, "\" was called but Intercom has not booted yet. "), "Please call 'boot' before calling '".concat(n, "' or "), "set 'autoBoot' to true in the IntercomProvider."].join(""));
      return;
    }

    return i();
  }, [d]),
      S = o.useCallback(function () {
    p.current && (s("shutdown"), delete window.intercomSettings, p.current = !1);
  }, []),
      D = o.useCallback(function () {
    p.current && (s("shutdown"), delete window.Intercom, delete window.intercomSettings, p.current = !1);
  }, []),
      M = o.useCallback(function () {
    a("update", function () {
      var n = Math.floor(new Date().getTime() / 1e3);
      s("update", {
        last_request_at: n
      });
    });
  }, [a]),
      E = o.useCallback(function (n) {
    a("update", function () {
      if (!n) {
        M();
        return;
      }

      var i = y(n);
      window.intercomSettings = m(m({}, window.intercomSettings), i), s("update", i);
    });
  }, [a, M]),
      T = o.useCallback(function () {
    a("hide", function () {
      s("hide");
    });
  }, [a]),
      $ = o.useCallback(function () {
    a("show", function () {
      return s("show");
    });
  }, [a]),
      V = o.useCallback(function () {
    a("showMessages", function () {
      s("showMessages");
    });
  }, [a]),
      z = o.useCallback(function (n) {
    a("showNewMessage", function () {
      n ? s("showNewMessage", n) : s("showNewMessage");
    });
  }, [a]),
      L = o.useCallback(function () {
    return a("getVisitorId", function () {
      return s("getVisitorId");
    });
  }, [a]),
      N = o.useCallback(function (n) {
    a("startTour", function () {
      s("startTour", n);
    });
  }, [a]),
      q = o.useCallback(function (n, i) {
    a("trackEvent", function () {
      i ? s("trackEvent", n, i) : s("trackEvent", n);
    });
  }, [a]),
      O = o.useCallback(function (n) {
    return a("showArticle", function () {
      s("showArticle", n);
    });
  }, [a]),
      B = o.useCallback(function (n) {
    a("startSurvey", function () {
      s("startSurvey", n);
    });
  }, [a]),
      te = o.useMemo(function () {
    return {
      boot: C,
      shutdown: S,
      hardShutdown: D,
      update: E,
      hide: T,
      show: $,
      isOpen: k,
      showMessages: V,
      showNewMessage: z,
      getVisitorId: L,
      startTour: N,
      trackEvent: q,
      showArticle: O,
      startSurvey: B
    };
  }, [C, S, D, E, T, $, k, V, z, L, N, q, O, B]);
  return o.createElement(P.Provider, {
    value: te
  }, c);
},
    Q = function Q() {
  var e = o.useContext(P);
  if (e === void 0) throw new Error('"useIntercom" must be used within `IntercomProvider`.');
  return e;
};

var ue = function ue() {
  return Q();
};

export { me as IntercomProvider, ue as useIntercom }; //# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map